/* ng-infinite-scroll - v1.0.0 - 2013-02-23 - PATCHED for mobile support */
var mod;
mod = angular.module("infinite-scroll", []);
mod.directive("infiniteScroll", ["$rootScope", "$window", "$timeout", function($rootScope, $window, $timeout) {
    return {
        link: function(scope, element, attrs) {
            var windowElement = angular.element($window);
            var scrollDistance = 0;
            var scrollEnabled = true;
            var checkWhenEnabled = false;
            var scrollThrottle = null;
            var THROTTLE_DELAY = 100; // ms

            // Watch for distance parameter changes
            if (attrs.infiniteScrollDistance != null) {
                scope.$watch(attrs.infiniteScrollDistance, function(value) {
                    scrollDistance = parseInt(value, 10) || 0;
                });
            }

            // Watch for disabled parameter changes
            if (attrs.infiniteScrollDisabled != null) {
                scope.$watch(attrs.infiniteScrollDisabled, function(value) {
                    scrollEnabled = !value;
                    if (scrollEnabled && checkWhenEnabled) {
                        checkWhenEnabled = false;
                        checkScroll();
                    }
                });
            }

            // Get viewport height - handles mobile browsers with dynamic address bars
            function getViewportHeight() {
                // Use visualViewport API if available (better for mobile)
                if ($window.visualViewport) {
                    return $window.visualViewport.height;
                }
                // Fallback to innerHeight (more reliable than jQuery height on mobile)
                return $window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            }

            // Get scroll position - handles various browser quirks
            function getScrollTop() {
                return $window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            }

            // Main scroll check function
            function checkScroll() {
                var viewportHeight = getViewportHeight();
                var scrollTop = getScrollTop();
                var elementRect = element[0].getBoundingClientRect();
                
                // Calculate the bottom of the element relative to viewport
                var elementBottom = elementRect.bottom;
                
                // Calculate threshold (viewport height * distance factor)
                var threshold = viewportHeight * scrollDistance;
                
                // Check if we're close enough to the bottom of the element
                var shouldLoadMore = elementBottom <= viewportHeight + threshold;

                if (shouldLoadMore && scrollEnabled) {
                    if ($rootScope.$$phase) {
                        scope.$eval(attrs.infiniteScroll);
                    } else {
                        scope.$apply(attrs.infiniteScroll);
                    }
                } else if (shouldLoadMore) {
                    checkWhenEnabled = true;
                }
            }

            // Throttled scroll handler to prevent excessive calls
            function throttledScrollHandler() {
                if (scrollThrottle) {
                    return;
                }
                scrollThrottle = $timeout(function() {
                    checkScroll();
                    scrollThrottle = null;
                }, THROTTLE_DELAY);
            }

            // Bind scroll events
            windowElement.on("scroll", throttledScrollHandler);
            
            // Also listen to touchmove for better mobile support
            windowElement.on("touchmove", throttledScrollHandler);
            
            // Listen to resize events (viewport changes on mobile)
            windowElement.on("resize", throttledScrollHandler);

            // Also listen on visualViewport resize if available (for mobile address bar changes)
            if ($window.visualViewport) {
                $window.visualViewport.addEventListener("resize", throttledScrollHandler);
                $window.visualViewport.addEventListener("scroll", throttledScrollHandler);
            }

            // Cleanup on scope destroy
            scope.$on("$destroy", function() {
                windowElement.off("scroll", throttledScrollHandler);
                windowElement.off("touchmove", throttledScrollHandler);
                windowElement.off("resize", throttledScrollHandler);
                
                if ($window.visualViewport) {
                    $window.visualViewport.removeEventListener("resize", throttledScrollHandler);
                    $window.visualViewport.removeEventListener("scroll", throttledScrollHandler);
                }
                
                if (scrollThrottle) {
                    $timeout.cancel(scrollThrottle);
                }
            });

            // Initial check after a short delay
            $timeout(function() {
                if (attrs.infiniteScrollImmediateCheck) {
                    if (scope.$eval(attrs.infiniteScrollImmediateCheck)) {
                        checkScroll();
                    }
                } else {
                    checkScroll();
                }
            }, 0);
        }
    };
}]);
